import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMentorshipProgramsPaginatedQueryVariables = Types.Exact<{
  workspaceId: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
  limit: Types.Scalars['Int']['input'];
}>;


export type GetMentorshipProgramsPaginatedQuery = { __typename?: 'query_root', mentorshipProgram: Array<{ __typename?: 'mentorshipProgram', id: number, name: string, createdAt?: any | null, mentorships: Array<{ __typename?: 'mentorship', id: any, mentorId: string, menteeId: string, mentor?: { __typename?: 'users', id: string, fullName?: string | null } | null, mentee?: { __typename?: 'users', id: string, fullName?: string | null } | null }>, mentorshipProgramModules: Array<{ __typename?: 'mentorshipProgramModule', id: number, name: string, mentorshipProgramProgresses: Array<{ __typename?: 'mentorshipProgramProgress', id: number, completed: boolean }> }> }> };


export const GetMentorshipProgramsPaginatedDocument = gql`
    query getMentorshipProgramsPaginated($workspaceId: Int!, $offset: Int!, $limit: Int!) {
  mentorshipProgram(
    where: {workspaceId: {_eq: $workspaceId}}
    order_by: {name: asc}
    offset: $offset
    limit: $limit
  ) {
    id
    name
    createdAt
    mentorships {
      id
      mentorId
      mentor {
        id
        fullName
      }
      menteeId
      mentee {
        id
        fullName
      }
    }
    mentorshipProgramModules {
      id
      name
      mentorshipProgramProgresses {
        id
        completed
      }
    }
  }
}
    `;

/**
 * __useGetMentorshipProgramsPaginatedQuery__
 *
 * To run a query within a React component, call `useGetMentorshipProgramsPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentorshipProgramsPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentorshipProgramsPaginatedQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetMentorshipProgramsPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetMentorshipProgramsPaginatedQuery, GetMentorshipProgramsPaginatedQueryVariables> & ({ variables: GetMentorshipProgramsPaginatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMentorshipProgramsPaginatedQuery, GetMentorshipProgramsPaginatedQueryVariables>(GetMentorshipProgramsPaginatedDocument, options);
      }
export function useGetMentorshipProgramsPaginatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMentorshipProgramsPaginatedQuery, GetMentorshipProgramsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMentorshipProgramsPaginatedQuery, GetMentorshipProgramsPaginatedQueryVariables>(GetMentorshipProgramsPaginatedDocument, options);
        }
export function useGetMentorshipProgramsPaginatedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMentorshipProgramsPaginatedQuery, GetMentorshipProgramsPaginatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMentorshipProgramsPaginatedQuery, GetMentorshipProgramsPaginatedQueryVariables>(GetMentorshipProgramsPaginatedDocument, options);
        }
export type GetMentorshipProgramsPaginatedQueryHookResult = ReturnType<typeof useGetMentorshipProgramsPaginatedQuery>;
export type GetMentorshipProgramsPaginatedLazyQueryHookResult = ReturnType<typeof useGetMentorshipProgramsPaginatedLazyQuery>;
export type GetMentorshipProgramsPaginatedSuspenseQueryHookResult = ReturnType<typeof useGetMentorshipProgramsPaginatedSuspenseQuery>;
export type GetMentorshipProgramsPaginatedQueryResult = Apollo.QueryResult<GetMentorshipProgramsPaginatedQuery, GetMentorshipProgramsPaginatedQueryVariables>;